import { convertIncludeTypeToNumber } from '../../../common/utilities/convert-include-type-to-number';
/**
 * @internal
 */
export var updateFilterWithProductStateExpression = function (filter, includeType) {
    var expressions = [filter, "(productState ge " + convertIncludeTypeToNumber(includeType) + ")"];
    return expressions.filter(function (x) { return !!x; })
        .join(' and ');
};
